import type { MeetingBasedEventTypeId } from '@ps/isp-web-services-types';

import { EventTypeId } from '../types/eventType';

const MEETING_BASED_EVENT_TYPE_IDS = new Set<EventTypeId>([
  EventTypeId.HORSE_RACING,
  EventTypeId.GREYHOUND_RACING
]);

export const isHorseRacing = (eventTypeId?: EventTypeId): eventTypeId is EventTypeId.HORSE_RACING =>
  eventTypeId === EventTypeId.HORSE_RACING;

export const isGreyhoundRacing = (
  eventTypeId?: EventTypeId
): eventTypeId is EventTypeId.GREYHOUND_RACING => eventTypeId === EventTypeId.GREYHOUND_RACING;

export const isMeetingBasedEventTypeId = (
  eventTypeId: EventTypeId
): eventTypeId is MeetingBasedEventTypeId => MEETING_BASED_EVENT_TYPE_IDS.has(eventTypeId);
